export function groupListByKey(data, key) {
  // O(n + m) instead of O(n * m)
  const arraryOfKeyValues = [...new Set(data.map(item => item[key]).sort())];
  if (!arraryOfKeyValues) return data;

  const listGroupedByKeyValues = {};

  data.forEach((item, i) => {
    if (!listGroupedByKeyValues[item[key]]) {
      listGroupedByKeyValues[item[key]] = [item];
    } else {
      listGroupedByKeyValues[item[key]].push(item);
    }
  });

  let groupedSortedList = [];
  let index = 0;
  let headerIndices = [];

  for (key in listGroupedByKeyValues) {
    headerIndices.push(index);
    index += 1 + listGroupedByKeyValues[key].length;

    groupedSortedList.push({
      tableHeader: `${key}`,
    });
    groupedSortedList = groupedSortedList.concat(listGroupedByKeyValues[key]);
  }

  return [groupedSortedList, headerIndices];
}

export function groupedTableData(data) {
  const arrayOfNames = arrayOfPropertyNames(data);
  if (!arrayOfNames) return data;
  let groupedTableData = [];

  arrayOfNames.forEach(propertyName => {
    groupedTableData.push({ tableHeader: propertyName, property: propertyName });
    groupedTableData = [
      ...groupedTableData,
      ...data.filter(rentRoll => rentRoll.property_name === propertyName),
    ];
  });

  return groupedTableData;
}

export function assignedMaintenanceHeaders(data) {
  for (let obj of data) {
    if (!obj.assigned_to) {
      obj.assigned_to = 'Unassigned';
    }
  }

  const arrayOfAssignedStaff = [...new Set(data.map(item => item.assigned_to).sort())];
  if (!arrayOfAssignedStaff) return data;
  let groupedTableData = [];

  arrayOfAssignedStaff.forEach(assignedStaffMember => {
    groupedTableData.push({ tableHeader: assignedStaffMember, property: assignedStaffMember });
    groupedTableData = [
      ...groupedTableData,
      ...data.filter(ticket => ticket.assigned_to === assignedStaffMember),
    ];
  });

  return groupedTableData.sort((a, b) => {
    if (a.id < b.id) return 1;
    if (b.id < a.id) return -1;
    return 0;
  });
}

export function arrayOfPropertyNames(tableData) {
  return [...new Set(tableData.map(item => item.property_name).sort())];
}

export const drawerStyle = {
  overrides: {
    MuiDrawer: {
      paperAnchorLeft: {
        maxWidth: '550px',
        width: '100% !important',
      },
      paperAnchorRight: {
        maxWidth: '550px',
        width: '100% !important',
      },
      paper: {
        height: '100% !important',
      },
    },
  },
};

export const buttonStyle = {
  overrides: {
    MuiButton: {
      root: {
        minWidth: '20px',
        minHeight: '20px',
        margin: '0 5px',
      },
    },
  },
};

export function frequencyHelper(frequencyType, frequency) {
  if (frequencyType === 1) return `${frequency} Hour(s)`;
  if (frequencyType === 2) return `${frequency} Day(s)`;
  if (frequencyType === 3) return `${frequency} Week(s)`;
  if (frequencyType === 4) return `${frequency} Month(s)`;
  if (frequencyType === 5) return `${frequency} Year(s)`;
}

export const alphabeticalColumnSort = (a, b) => {
  const compareA = typeof a === 'string' ? a.toUpperCase() : a;
  const compareB = typeof b === 'string' ? b.toUpperCase() : b;

  if (compareA < compareB) {
    return -1;
  }
  if (compareA > compareB) {
    return 1;
  }
  return 0;
};